import { cloneDeep } from 'lodash';
import { loginSessionMock } from 'modules/__mocks__/login-session.mock';

import {
    IGetProfilesResponse,
} from 'modules/ubisoft-connect-service/types';

export class OverlayServiceMock {
    public static hasInitialized = true;

    public static init() {}
    public static reInit() {}
    public static openLoginPopup() {}
    public static changeLocale(locale: string) {
        return locale;
    }
    
    public static async triggerEmailActivation(callback: Function) {
        return callback && callback();
    }

    public static async getUserStatus(callback: Function) {
        return callback && callback();
    }

    public static async getThirdPartyStatus() {
        return true;
    }

    public static async getTicket() {
        return {
            sessionId: '87942374-****-418c-****-edf0ecb3556e',
            ticket: '****.LONP2H-ESqR-A6meV1s_Ud9RIjYen3Ewa-_L_fWjRNA.****',
            userId: '****b2b9-0ba7-41f2-adca-e62d136e****',
        };
    }

    public static async getProfiles() {
        return {
            payload: {
                profiles: cloneDeep(loginSessionMock.UbisoftConnectProfiles)
            }
        } as IGetProfilesResponse;
    } 
}

